import { Button, CircularProgress } from "@mui/material";

export default function PrimaryButton({
  children,
  loading = false,
  disabled = false,
  type = "submit",
  onClick,
}) {
  return (
    <Button
      type={type}
      variant="contained"
      color="primary"
      fullWidth
      size="large"
      disableElevation
      onClick={onClick}
      disabled={loading || disabled}
      sx={{
        mt: 3,
        py: 1.6,
        borderRadius: 3,
        fontSize: "1rem",
        fontWeight: 600,
        textTransform: "none",
      }}
    >
      {loading ? (
        <>
          <CircularProgress size={22} color="inherit" sx={{ mr: 1 }} />
          Trwa zapisywanie...
        </>
      ) : (
        children
      )}
    </Button>
  );
}
